import { getToolProviderPrimaryContentKey } from './tool-provider-primary-content';
export function mergeToolProviderPreview({ body, providerId, override, }) {
    const primaryKey = getToolProviderPrimaryContentKey(providerId);
    const merged = { ...(override ?? {}) };
    if (!primaryKey) {
        return { merged };
    }
    if (!merged[primaryKey]) {
        merged[primaryKey] = body;
        return { merged, defaultContentKey: primaryKey };
    }
    return { merged };
}
//# sourceMappingURL=merge-tool-provider-preview.js.map